import React from 'react'
import Navbar from '../HomeComponents/Navbar';
import './ContactStyle.css'
import Thanksimg from './Images/Thanks.png'


export default function Thanks() {
    

     
    return (
        <>
            <Navbar />
            <div className="main-container-thanks">
                <div className="text-container-thanks">
                    <h1 className='contact-heading'>We are glad that you are a part of us now. <br /> Many Thanks :)</h1>
                    <p className="contact-text">We will contact you soon and update you with your friendly schedule. If you want u can check the location of your new destination on the map provided on the Homepage ;)</p>
                </div>
                <div className="form-container">
                   <img src={Thanksimg} className='thanks-img' alt="" />
                </div>
            </div>
        </>
    )
}
